import { ColumnHelper } from "PFComponents/table/table.types";
import { Typography } from "PFComponents/typography";

import { isOpenVacancyItem, SuggestedWmTableItem } from "../types";
import { MatchCell } from "./match_cell";

export const createMatchColumn = (columnHelper: ColumnHelper<SuggestedWmTableItem>, headerLabel: string) =>
  columnHelper.accessor(
    (row) => (isOpenVacancyItem(row) ? undefined : (row?.scores?.normalizedScore ?? undefined)),
    {
      id: "match",
      header: () => (
        <Typography withMargin variant="labelRegular">
          {headerLabel}
        </Typography>
      ),
      cell: (info) => {
        const item = info.row.original;
        if (isOpenVacancyItem(item)) {
          return null;
        }
        return <MatchCell shortlist={item} />;
      },
      sortFn: (rowA, rowB) => {
        const scoreA = isOpenVacancyItem(rowA.original) ? 0 : (rowA.original.scores?.normalizedScore ?? 0);
        const scoreB = isOpenVacancyItem(rowB.original) ? 0 : (rowB.original.scores?.normalizedScore ?? 0);
        return scoreA - scoreB;
      },
      sortUndefined: "last"
    }
  );
